import script from "./CsUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./CsUpload.vue?vue&type=script&setup=true&lang=js"

import "./CsUpload.vue?vue&type=style&index=0&id=fb858756&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb858756"]])

export default __exports__